import { RouteObject } from 'react-router-dom';
import CardsLandingResponsive from '../components/ResponsiveWrapper/Cards/CardsLandingResponsive';
import CardsListResponsive from '../components/ResponsiveWrapper/Cards/CardsListResponsive';
import CreditHistoryResponsive from '../components/ResponsiveWrapper/Cards/CreditHistoryResponsive';
import PackShopResponsive from '../components/ResponsiveWrapper/Cards/PackShopResponsive';
import LeaderboardResponsive from '../components/ResponsiveWrapper/Cards/LeaderboardResponsive';
import ExpansionsProgressResponsive from '../components/ResponsiveWrapper/Cards/ExpansionsProgressResponsive';
import UserProfileResponsive from '../components/ResponsiveWrapper/Cards/UserProfileResponsive';
import { CardsListLoader } from '../loaders/CardsListLoader';
import CardShopResponsive from '../components/ResponsiveWrapper/Cards/CardShopResponsive';
import QuizResponsive from '../components/ResponsiveWrapper/Cards/QuizResponsive';
import QuizLeaderboardResponsive from '../components/ResponsiveWrapper/Cards/QuizLeaderboardResponsive';
import LeastOwnedCardsResponsive from '../components/ResponsiveWrapper/Cards/LeastOwnedCardsResponsive';
import CediCarteResponsive from '../components/ResponsiveWrapper/Cards/CediCarteResponsive';

export const cardsRoutes: RouteObject = {
  path: 'carte',
  children: [
    { index: true, element: <CardsLandingResponsive /> },
    { path: 'lista', element: <CardsListResponsive />, loader: CardsListLoader },
    { path: 'storico', element: <CreditHistoryResponsive /> },
    { path: 'pacchetti', element: <PackShopResponsive /> },
    { path: 'classifica', element: <LeaderboardResponsive /> },
    { path: 'espansioni', element: <ExpansionsProgressResponsive /> },
    { path: 'utente/:username', element: <UserProfileResponsive /> },
    { path: 'negozio', element: <CardShopResponsive /> },
    { path: 'quiz', element: <QuizResponsive /> },
    { path: 'quiz/classifica', element: <QuizLeaderboardResponsive /> },
    { path: 'introvabili', element: <LeastOwnedCardsResponsive /> },
    { path: 'cedi', element: <CediCarteResponsive /> },
  ],
};
